import { render } from "./seesJobmindReferCard.vue?vue&type=template&id=90b22dd8&scoped=true"
import script from "./seesJobmindReferCard.vue?vue&type=script&lang=js"
export * from "./seesJobmindReferCard.vue?vue&type=script&lang=js"

import "./seesJobmindReferCard.vue?vue&type=style&index=0&id=90b22dd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b22dd8"]])

export default __exports__